import _chunk from "lodash/chunk";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React, { useRef } from 'react';
import { PillButton } from "../PillButton";
import { flushSync } from 'react-dom';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var NUM_COLUMNS = 4;
export var YEAR_PICKER_PAGE_SIZE = 24;
export function YearPickerLayout(_ref) {
  var goToNextPage = _ref.goToNextPage,
    goToPreviousPage = _ref.goToPreviousPage,
    maxDate = _ref.maxDate,
    minDate = _ref.minDate,
    onChange = _ref.onChange,
    value = _ref.value,
    years = _ref.years;
  var isSelectedYearInView = years.includes(value);
  var ref = useRef(null);
  var rows = _chunk(years, NUM_COLUMNS);
  var focusOnDateBtn = function focusOnDateBtn(index) {
    var _ref$current;
    return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll('button').item(index).focus();
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    _jsx("table", {
      ref: ref,
      role: "grid",
      children: _jsx("tbody", {
        children: rows.map(function (row, rowIndex) {
          return _jsx("tr", {
            children: row.map(function (year, colIndex) {
              return _jsx("td", {
                children: _jsx(PillButton, {
                  isSelected: year === value,
                  onClick: function onClick() {
                    return onChange(year);
                  },
                  onKeyDown: function onKeyDown(e) {
                    var amount = e.key === 'ArrowUp' ? -NUM_COLUMNS : e.key === 'ArrowDown' ? NUM_COLUMNS : e.key === 'ArrowLeft' ? -1 : e.key === 'ArrowRight' ? 1 : 0;
                    var currentIndex = years.findIndex(function (val) {
                      return val === year;
                    });
                    var newIndex = currentIndex + amount;
                    var yearToGoTo = year + amount;
                    if (amount === 0 || yearToGoTo > maxDate.getFullYear() || yearToGoTo < minDate.getFullYear()) {
                      return;
                    }
                    if (newIndex < 0) {
                      flushSync(function () {
                        return goToPreviousPage();
                      });
                      focusOnDateBtn(YEAR_PICKER_PAGE_SIZE + newIndex);
                    } else if (newIndex >= years.length) {
                      flushSync(function () {
                        return goToNextPage();
                      });
                      focusOnDateBtn(newIndex % NUM_COLUMNS);
                    } else {
                      focusOnDateBtn(newIndex);
                    }
                    e.preventDefault();
                  },
                  tabIndex: year === value ? 0 : (!value || !isSelectedYearInView) && rowIndex === 0 && colIndex === 0 ? 0 : -1,
                  variant: "year",
                  children: year.toString()
                }, year)
              }, colIndex);
            })
          }, rowIndex);
        })
      })
    })
  );
}